import { render, staticRenderFns } from "./TestQuestion.vue?vue&type=template&id=b7ea99c6&scoped=true&"
import script from "./TestQuestion.vue?vue&type=script&lang=js&"
export * from "./TestQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TestQuestion.vue?vue&type=style&index=0&id=b7ea99c6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ea99c6",
  null
  
)

export default component.exports